module.exports = __webpack_public_path__ + "static/media/Alba soffa U-soffa FS 210_3 OEBR tyg genesis Dove 3 miljö modell 2024 fyrkant.58cee161.jpg";